export interface Time {
	time: string;
	date_time_local: string;
}

export interface AvailableAppointment {
	date: string;
	time: Time[];
}

export interface Appointment {
	date: string;
	time: string;
}

export const SCHEDULER_INTRO = `Here are the next available appointments.`;
export const LEAD_FORM_INTRO = `Excellent - to finalize your appointment, just provide a few more details and you're all set.`;

export interface BookAppointmentResponse {
	message: string;
	success?: boolean;
}

export interface AvailableAppointmentsResponse {
	appointments?: AvailableAppointment[];
	message?: string;
}
